



























import  {Component} from "vue-property-decorator";
import DatenschutzFaTab from "./Generic/DatenschutzFaTab.vue";

@Component({})
export default class DatenschutzFa3Einbeziehnung extends DatenschutzFaTab {


}
